import React from 'react';
import { useLocation, Navigate, Outlet } from 'react-router-dom';
//import useAuth from "../../hooks/useAuth";

const RequireAuth = () => {
    const data = localStorage.getItem("data");
    const location = useLocation();
  return (
    data
        ? <Outlet />
        : <Navigate to='/' state={{ from: location}} replace />
    )
}

export default RequireAuth;